/* A one-line event channel for "the tenant's settings were saved".

   The Settings dialog and the import wizard cannot see each other: the dialog
   lives in AppShell, the wizard is a route provider underneath it, and neither
   is the other's parent in a way that makes a context value natural. What they
   share is a global fact — a save happened — so a module-level registry says it
   without threading a callback through the shell.

   The wizard subscribes to drop its cached validation report. That report is
   computed against the tenant's settings, so a user who turned on auto-create
   because the preview complained must not be left looking at the old report
   still saying nothing will be created. */
type Listener = () => void

const listeners = new Set<Listener>()

/** Called by whoever performs the save, after it has actually succeeded. */
export function notifySettingsSaved(): void {
  // Copy first: a listener that unsubscribes while being notified would
  // otherwise mutate the set mid-iteration.
  for (const listener of [...listeners]) listener()
}

/** Returns an unsubscribe function, for use in a React effect's cleanup. */
export function onSettingsSaved(listener: Listener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
